import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("mtw_cart") || "[]"); } catch { return []; }
  });
  const [branchId, setBranchId] = useState(() => localStorage.getItem("mtw_branch") || "");

  useEffect(() => { localStorage.setItem("mtw_cart", JSON.stringify(items)); }, [items]);
  useEffect(() => { if (branchId) localStorage.setItem("mtw_branch", branchId); }, [branchId]);

  const add = (product, qty = 1) => setItems((prev) => {
    const ex = prev.find((i) => i.product_id === product.id);
    if (ex) return prev.map((i) => i.product_id === product.id ? { ...i, qty: i.qty + qty } : i);
    return [...prev, { product_id: product.id, name_ar: product.name_ar, name_en: product.name_en, price: product.price, image: product.image, qty }];
  });
  const setQty = (pid, qty) => setItems((prev) => qty <= 0 ? prev.filter((i) => i.product_id !== pid) : prev.map((i) => i.product_id === pid ? { ...i, qty } : i));
  const remove = (pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal, branchId, setBranchId }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
